export const MAX_TICKETS_ZERO_ERROR = "Use 1 or more, or leave it blank for no limit. To sell only at the box office, set the ticket to At the door only.";

export const maxTicketsError = (value) => (value != null && value !== "" && parseInt(value, 10) === 0 ? MAX_TICKETS_ZERO_ERROR : null);
